export function init_variation(variation) {
  $('td.label', variation).append('<img src="/wp-content/themes/Heimdall/img/arrow.svg">');
  $('td.value', variation).prepend('<div class="options"></div>');

  $('td.value option', variation).each(function(){
    if ($(this).val().length > 0) {
      $('.options', variation).append('<div data-value="'+$(this).val()+'">'+$(this).text()+'</div>');
    }
  });

  $('td.label',variation).click(function() {
    if ($('td.value .options',variation).is(':visible')) {
      $('td.value .options',variation).slideUp();
      $('td.label img',variation).removeClass('open');
    } else {
      $('td.label img',variation).addClass('open');
      $('td.value .options',variation).slideDown();
    }
  });

  $('.options div',variation).click(function() {
    var value = $(this).attr('data-value');
    $('.options div',variation).removeClass('active');
    $('select',variation).val(value).change();
    $(this).addClass('active');

    var price = $('.single_variation_wrap .woocommerce-variation-price').text();

    if (price.length > 0) {
      if ($('.product-price-custom').length > 0) {
        $('.product-price-custom').text(price);
      } else {
        $('.product-price').after('<div class="product-price-custom">'+price+'</div>');
      }
      $('.product-price').hide();
    }
  });

  $('.reset_variations').click(function(){
    $('.options div').removeClass('active');
    $('.product-price').show();
    $('.product-price-custom').remove();
  });
}

// toggles "Fraktinfo"-information on productpage
export function init_product_info() {
  $('#primary .product-info-tabs-tab',).click( function() {
    if($('#primary .product-info-tabs-tab .content').hasClass('open')) {
      $('#primary .product-info-tabs-tab .content').slideUp();
      $('#primary .product-info-tabs-tab .content').removeClass('open');
    } else {
      $('#primary .product-info-tabs-tab .content').slideDown();
      $('#primary .product-info-tabs-tab .content').addClass('open');
    }
  });
}
